__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-02-1775118170-stable-dev/";